module.exports = __webpack_public_path__ + "img/logo-mini.55b6ae41.jpg";